 <template>
  <EMCoreTemplate category="Core" identity="contact" entity="crm_contact"></EMCoreTemplate>
</template>
<script type="text/javascript">
  import {EMCoreTemplate} from '@/Adm/components' 
  export default{
    name: 'Contact',
    components:{
      EMCoreTemplate
    } 
  }


</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementCore/containers/Contact.vue